// extracted by mini-css-extract-plugin
export var carrierIconPlaceholder = "_9n-1";
export var dragButton = "_9n-5";
export var sortableCell = "_9n-4";
export var sortableNameCell = "_9n-3";
export var sortableRow = "_9n-0";
export var tableHeader = "_9n-6";
export var tableHeaderWithCardHeader = "_9n-7";
export var weightInputRow = "_9n-2";